import { useRef } from "react";

const useIsInitialRender = () => {
  const ref = useRef<boolean>(true);

  if (ref?.current) {
    ref.current = false;
    return true;
  }

  return ref.current;
};

export default useIsInitialRender;
